import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import axiosInstance from "../config/axios-config";

export default function useTenantUsers() {
    const {i18n} = useTranslation();
    const [query, setQuery] = useState({role: "", active: "", search: "", page: 0, size: 20, sort: "createdAt,desc"});
    const [result, setResult] = useState({content: [], totalElements: 0, loading: true, error: ""});
    const [version, setVersion] = useState(0);
    const lastSearch = useRef("");
    const language = i18n.language;

    useEffect(() => {
        const controller = new AbortController();
        setResult({content: [], totalElements: 0, loading: true, error: ""});
        // Debounce typing and cancel obsolete requests so only current results are displayed.
        const timeout = setTimeout(async () => {
            lastSearch.current = query.search;
            try {
                const {data} = await axiosInstance.get("/api/v1/users/all", {
                    signal: controller.signal,
                    params: {...query, role: query.role || undefined, active: query.active || undefined,
                        search: query.search.trim() || undefined},
                    headers: {"Language-Context": language.toUpperCase()},
                });
                if (controller.signal.aborted) return;
                if (data.totalPages > 0 && query.page >= data.totalPages) {
                    setQuery(previous => ({...previous, page: data.totalPages - 1}));
                    return;
                }
                setResult({content: data.content, totalElements: data.totalElements, loading: false, error: ""});
            } catch (error) {
                if (!controller.signal.aborted) setResult({content: [], totalElements: 0, loading: false,
                    error: error.response?.data?.message || "TenantUsersLoadFailed"});
            }
        }, query.search === lastSearch.current ? 0 : 400);
        return () => { clearTimeout(timeout); controller.abort(); };
    }, [query, language, version]);

    const changeFilter = (field, value) => setQuery(previous => ({...previous, [field]: value, page: 0}));
    const refresh = () => { setQuery(previous => ({...previous, page: 0})); setVersion(value => value + 1); };
    return {query, ...result, changeFilter, setPage: page => setQuery(previous => ({...previous, page})), refresh};
}
